import { render, staticRenderFns } from "./ProposalSearch.vue?vue&type=template&id=635055ed"
import script from "./ProposalSearch.vue?vue&type=script&lang=js"
export * from "./ProposalSearch.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports